import script from "./ChatListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatListItem.vue?vue&type=script&setup=true&lang=js"

import "./ChatListItem.vue?vue&type=style&index=0&id=469e120a&lang=scss"

const __exports__ = script;

export default __exports__